import { Component } from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

// Contains a crash to one page/tab so the sidebar, header and other tabs keep working.
export class ErrorBoundary extends Component {
  state = { error: null, n: 0 };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error(`[${this.props.label || "section"}] crashed:`, error, info?.componentStack);
  }

  componentDidUpdate(prev) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }

  render() {
    const { error, n } = this.state;
    if (!error) return <div key={n} className="contents">{this.props.children}</div>;
    return (
      <div className="panel my-4 border-red-300 bg-red-50 p-5 text-sm text-red-800" data-testid={`error-boundary-${this.props.testid || "section"}`}>
        <div className="flex items-center gap-2 font-semibold"><AlertTriangle className="h-4 w-4" /> Something went wrong in this section</div>
        <div className="mt-1 break-words font-mono text-xs" data-testid="error-boundary-message">{String(error?.message || error)}</div>
        <div className="mt-1 text-xs text-red-700">The rest of the app still works. No data was changed.</div>
        <Button size="sm" variant="outline" className="mt-3" onClick={() => this.setState({ error: null, n: n + 1 })} data-testid="error-boundary-reload-btn">
          <RotateCcw className="h-4 w-4" /> Reload section
        </Button>
      </div>
    );
  }
}
